import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import _ from "lodash";
import ResetPassword from "../Onboarding/UserRegister/ResetPassword";
import AgentInfoModal from "../Onboarding/UserRegister/v2/AgentInfoModal";
import AgentLiketoStartModal from "../Onboarding/UserRegister/AgentLiketoStartModal";
import EmailVerifiedModal from "../Onboarding/UserRegister/EmailVerifiedModal";
import EmailChangeConfirmedModal from "../Onboarding/UserRegister/EmailChangeConfirmedModal";
import EmailChangeRevokedModal from "../Onboarding/UserRegister/EmailChangeRevokedModal";
import CheckEmailDeletionModal from "../Onboarding/UserRegister/CheckEmailDeletionModal";
import BasicPlanModal from "../PlanUpgrade/BasicPlanModal";
import PremiumPlanModal from "../PlanUpgrade/PremiumPlanModal";
import AgentOnboardingModalWrapper from "../Onboarding/UserRegister/AgentOnboardingModalWrapper";
import CheckResetEmailModal from "../Onboarding/UserRegister/CheckResetEmailModal";
import SupportTicketModal from "../SupportTicket/SupportTicketModal";
import DeleteNotificationModalNew from "../Onboarding/DeleteNotificationModalNew";
import WantAdRenewConfirmationModal from "../Onboarding/WantAdRenewConfirmationModal";
import ProfileImageCropper from "@/components/ProfileImageCropper";
import Introductions from "../HeaderButtons/Introductions";
import Notifications from "../HeaderButtons/Notifications";
import MemberUserProfileModal from "../Onboarding/UserRegister/MemberUserProfileModal";

import {
  INAPPNOTIFICATIONCOUNT,
  NOTIFICATIONCOUNT,
  USER_TYPE_AGENT,
} from "../../constants/common";
import { getLocalStorage, getUserType } from "../../helpers/common";
import { Button } from "react-bootstrap";
import { LOGIN, SIGNUP } from "@/constants/onBoarding";
import CheckAgentModal from "../Onboarding/UserRegister/CheckAgentModal";
import AgentTitleModal from "../Onboarding/UserRegister/AgentTitleModal";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";
import { useAppConfig } from "@/appConfig";
import { isSSOLogin } from "@/helpers/crossLoginHelper";

const BaseHeader = (allProps) => {

  const {
    headerContent,
    headerButtons,
    ...props
  } = allProps;

  const {
    UserId,
    userDetails,
    email,
    agentTitleModalShow,
    agentProfileModal,
    selectedTitle,
    titleContinueState,
    showEmailVerifiedModal,
    showEmailConfirmedModal,
    showEmailChangeRevokedModal,
    checkEmailPopup,
    emailNotVerified,
    showPremiumPlanModal,
    showBasicPlanModal,
    agentOnboardingPopup,
    resetPwdModal,
    resetPwdModalType,
    resetEmailModalState,
    image,
    showPofileImageUploadModal,
    reRenderEditProfileModel,
    uploadedImageUrl,
    PremiumPlanModalClose,
    BasicPlanModalClose,
    ContactModalClose,
    ShowPofileImageUploadModalClose,
    handleUserTypeModal,
    handleAgentTitleModal,
    handleAgentTitleModalDismiss,
    handleMemberProfileModal,
    handleEmailVerifiedModalClose,
    handleEmailConfirmedModalClose,
    handleEmailChangeRevokedModalClose,
    handleCheckEmailDeletionModalClose,
    handleResetEmailModal,
    handleAgentTitleContinueClick,
    handleResetPwdModal,
    handleAgentOnboardingModal,
    resetPassWord,
    handleUserLogin,
    handleTitleClick,
    saveAgentDetails,
    updateReloadParam,
    renderEditProfileModel,
    setImage,
    memberProfileModal,
    ShowPofileImageUploadModalShow,
    userTypeModalShow,
    handleUserTypeModalDismiss,
    handleUserTypeContinueClick,
    handleUserTypeSelection,
    userType,
    isDisabledUserContinue,
    userData,
  } = props;

  return (
    <>
      {headerContent}

      {memberProfileModal && <MemberUserProfileModal show={memberProfileModal} onHide={() => handleMemberProfileModal({ showModal: false })} />}

      {userTypeModalShow && (
        <CheckAgentModal
          show={userTypeModalShow}
          onCancel={handleUserTypeModalDismiss}
          handleUserTypeContinueClick={handleUserTypeContinueClick}
          handleUserTypeSelection={handleUserTypeSelection}
          isDisabled={
            _.get(userData, "userInfo.userType", null)
              ? false
              : isDisabledUserContinue
          }
          selectedType={userType || _.get(userData, "userInfo.userType", null)}
        />
      )}

      {agentTitleModalShow && (
        <AgentTitleModal
          show={agentTitleModalShow}
          onCancel={handleAgentTitleModalDismiss}
          handleAgentContinueClick={handleAgentTitleContinueClick}
          handleTitleClick={handleTitleClick}
          titleContinueState={titleContinueState}
          selectedTitle={selectedTitle}
          handleUserTypeModal={handleUserTypeModal}
          setAgentTitleModal={handleAgentTitleModal}
          hideBackButton={isSSOLogin()}
        />
      )}

      {agentProfileModal && (
        <AgentInfoModal
          show={agentProfileModal}
          saveAgentDetails={saveAgentDetails}
          UserId={UserId}
          onClickChangePhoto={(image) => {
            ShowPofileImageUploadModalShow();
            setImage(image);
          }}
          reRenderEditProfileModel={reRenderEditProfileModel}
          uploadedImageUrl={uploadedImageUrl}
        />
      )}

      <ProfileImageCropper
        userId={UserId}
        image={image}
        show={showPofileImageUploadModal}
        onHide={() => {
          ShowPofileImageUploadModalClose();
        }}
        updateImageAfterCrop={(imageUrl) => {
          renderEditProfileModel(imageUrl);
          ShowPofileImageUploadModalClose();
        }}
      />

      <AgentLiketoStartModal />

      <EmailVerifiedModal
        show={showEmailVerifiedModal}
        onHide={handleEmailVerifiedModalClose}
      />

      <EmailChangeConfirmedModal
        show={showEmailConfirmedModal}
        onHide={handleEmailConfirmedModalClose}
        emailNotVerified={emailNotVerified}
      />

      <EmailChangeRevokedModal
        show={showEmailChangeRevokedModal}
        onHide={handleEmailChangeRevokedModalClose}
      />

      <CheckEmailDeletionModal
        process="deletion"
        show={checkEmailPopup}
        hide={handleCheckEmailDeletionModalClose}
      />

      <PremiumPlanModal
        userDetails={userDetails}
        show={showPremiumPlanModal}
        onHide={PremiumPlanModalClose}
        updateReloadParam={updateReloadParam}
        handleShowAgentModal={props?.handleShowAgentModal}
        handleAgentTitleModal={handleAgentTitleModal}
        showPlanModal={props?.PremiumPlanModalShow}
      />

      <BasicPlanModal
        userDetails={userDetails}
        show={showBasicPlanModal}
        onHide={BasicPlanModalClose}
        updateReloadParam={updateReloadParam}
        handleMemberProfileModal={handleMemberProfileModal}
        handleUserTypeModal={handleUserTypeModal}
        showPlanModal={props?.BasicPlanModalShow}
      />

      <AgentOnboardingModalWrapper
        agentOnboardingPopup={agentOnboardingPopup}
        saveAgentDetails={saveAgentDetails}
        handleMemberProfileModal={handleMemberProfileModal}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
        handleUserTypeModal={handleUserTypeModal}
        handleResetPwdModal={handleResetPwdModal}
        handleUserLogin={handleUserLogin}
      />

      <ResetPassword
        resetPwdModal={resetPwdModal}
        handleResetPwdModal={handleResetPwdModal}
        resetPwdModalType={resetPwdModalType}
        resetPassWord={resetPassWord}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
      />

      <CheckResetEmailModal
        show={resetEmailModalState}
        onHide={handleResetEmailModal}
        email={email}
        process="ResetPwd"
      />

      <SupportTicketModal
        show={props?.contactModalState}
        onHide={ContactModalClose}
      />

    </>
  );
};

export default BaseHeader;

export const AuthButtons = (props) => {
  const { showSignUpButton = true, className = "" } = props;

  const { tenant } = useAppConfig()

  const handleSignIn = () => {
    // BLS tenants (those with an ssoProvider in tenant config) authenticate via
    // their MLS identity provider instead of the Gitcha login modal.
    if (tenant?.ssoProvider) {
      const baseAPIURL = process.env.REACT_APP_API_BASE_URL;
      if (tenant.ssoType === "saml") {
        return (window.location.href = `${baseAPIURL}api/v2/auth/saml/${tenant.ssoProvider}/login`);
      }
      if (tenant.ssoType === "oicd") {
        return (window.location.href = `${baseAPIURL}api/v2/auth/oauth/${tenant.ssoProvider}/authorize`);
      }
    }
    props?.handleAgentOnboardingModal({
      showPopup: true,
      userAction: LOGIN,
    });
  };

  return (
    <div className={className}>
      <Button
        variant="secondary"
        className="btn-ml-6 mr-0 btn-tweak"
        onClick={handleSignIn}
      >
        {props?.signInText || "Sign In"}
      </Button>{" "}
      {showSignUpButton && (
        <Button
          variant="primary"
          className="btn-ml-6 mr-0 btn-tweak"
          onClick={() =>
            props?.handleAgentOnboardingModal({
              showPopup: true,
              userAction: SIGNUP,
            })
          }
        >
          {props?.signUpText || "Sign Up"}
        </Button>
      )}
    </div>
  )
};

export const CommonHeaderButtons = (props) => {

  const {
    user,
    headerLogic,
    className = "",
    isPremium = false,
    showOnMobile = false,
  } = props;

  const {
    introductionList,
    isLoadIntroList,
    unreadMessageCount,
    notificationList,
    isLoadNotificationList,
    unreadNotificationMessageCount,
    unreadInappNotificationCount,
    unreadChatCount,
    dmMessageCount,
    deleteNotificationModal,
    wantAdRenewModal,
    handleHandShakeClick,
    updateIntroStateonHover,
    updateIntroPageOnScroll,
    handleCloseIntroList,
    updateInAppStatusonHover,
    updateInAppDeleteStatusOnClick,
    renewWantAd,
    onDeleteInappNotification,
    onConfirmReniewWantAdClicked,
    handleDeleteNotificationPopupClose,
    handleWantAdRenewPopupClose,
  } = headerLogic;

  const navigate = (path) => {
    window.location.href = path;
  };

  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  if (!user) return null;

  const visibilityClass = showOnMobile ? "" : "d-none d-lg-block";

  const introCount = unreadMessageCount || _.get(getLocalStorage(NOTIFICATIONCOUNT), "count", 0) || 0;
  const chatCount = (unreadChatCount || 0) + (dmMessageCount || 0);
  const alertsCount = unreadInappNotificationCount
    || unreadNotificationMessageCount
    || _.get(getLocalStorage(INAPPNOTIFICATIONCOUNT), "count", 0)
    || 0;

  return (
    <div className={`toplinks d-flex ${className}`}>
      <Dropdown
        className={`introduction-btn position-relative ${visibilityClass}`}
        autoClose={true}
        onClick={() => {
          handleHandShakeClick();
          props?.setDeleteNotificationModal?.(false);
        }}
      >
        <Dropdown.Toggle
          id="dropdown-basic56"
          className={`ml-6 mr-6 common-links handshake-icon ${isPremium ? "common-links-premium handshake-icon-premium" : ""
            } border-0 p-0 position-relative`}
          variant=""
          align="end"
        >
          {introCount > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill notification-bg-red txt-display">
                {introCount}
                <span className="visually-hidden">unread introductions</span>
              </span>
            )}
          handshake
        </Dropdown.Toggle>
        <Dropdown.Menu align={"end"} data-bs-popper="none">
          <Introductions
            list={introductionList}
            updateIntroStateonHover={updateIntroStateonHover}
            updateIntroPageOnScroll={updateIntroPageOnScroll}
            isLoadIntroList={isLoadIntroList}
            handleCloseIntroList={handleCloseIntroList}
          />
        </Dropdown.Menu>
      </Dropdown>

      {shouldRestrictAgent ? <></> : (
        <a
          className={`nav-link common-links ml-6 mr-6 chat-icon position-relative ${visibilityClass} ${isPremium ? "chat-icon-premium common-links-premium" : ""
            }`}
          aria-current="page"
          onClick={() => navigate("/messages")}
        >
          {chatCount > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill notification-bg-red txt-display">
              {chatCount}
              <span className="visually-hidden">unread messages</span>
            </span>
          )}
          chat
        </a>
      )}

      <Dropdown
        className={`notification-btn position-relative ${visibilityClass}`}
        autoClose={true}
        onClick={() => {
          updateInAppStatusonHover();
        }}
      >
        <Dropdown.Toggle
          id="dropdown-basic56"
          className={`ml-6 mr-6 common-links bell-icon ${isPremium ? "bell-icon-premium common-links-premium" : ""
            } border-0 p-0 position-relative`}
          variant=""
        >
          {alertsCount > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill notification-bg-red txt-display">
                {alertsCount}
                <span className="visually-hidden">unread alerts</span>
              </span>
            )}
          bell
        </Dropdown.Toggle>
        <Dropdown.Menu align={"end"} data-bs-popper="none" className="">
          <div
            className={
              deleteNotificationModal
                ? "w-100 mh-365 position-relative notif-modal-container"
                : "w-100 h-100 position-relative notif-modal-container"
            }
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Notifications
              list={notificationList}
              isLoadNotificationList={isLoadNotificationList}
              onDeleteInappNotification={() => onDeleteInappNotification()}
              updateInAppDeleteStatusOnClick={updateInAppDeleteStatusOnClick}
              renewWantAd={(notification) => {
                renewWantAd(notification);
              }}
            />

            <DeleteNotificationModalNew
              show={deleteNotificationModal}
              onHide={handleDeleteNotificationPopupClose}
              onConfirm={updateInAppDeleteStatusOnClick}
            />

            <WantAdRenewConfirmationModal
              show={wantAdRenewModal}
              onHide={handleWantAdRenewPopupClose}
              onConfirmReniewWantAd={onConfirmReniewWantAdClicked}
            />
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
